import { render } from "./ViewEachCustomer.vue?vue&type=template&id=351f8709"
import script from "./ViewEachCustomer.vue?vue&type=script&lang=js"
export * from "./ViewEachCustomer.vue?vue&type=script&lang=js"

import "./ViewEachCustomer.vue?vue&type=style&index=0&id=351f8709&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__